import type { ElementType } from 'react';
import { LayoutDashboard, Wrench, ClipboardList, CloudSun, Settings } from 'lucide-react';

export interface NavItem {
  name: string;
  href: string;
  icon: ElementType;
  /** Secondary line under the label. */
  description?: string;
  /** Path prefixes that mark this item active (defaults to href). */
  activePaths?: string[];
}

/** Primary topbar / mobile-drawer links (any authenticated user). */
export const mainNav: NavItem[] = [
  { name: 'Dashboard', href: '/', icon: LayoutDashboard, activePaths: ['/'] },
  {
    name: 'Calibrations',
    href: '/calibrations',
    icon: Wrench,
    activePaths: ['/calibrations'],
  },
];

/** Manage dropdown children — UI + routes are admin-only. */
export const manageNav: NavItem[] = [
  {
    name: 'Acceptance Criteria',
    href: '/manage/acceptance-criteria',
    icon: ClipboardList,
    description: 'Manage acceptance criteria',
    activePaths: ['/manage/acceptance-criteria'],
  },
  {
    name: 'Environmental Data',
    href: '/manage/daily-environmental-data',
    icon: CloudSun,
    description: 'Daily environmental readings',
    activePaths: ['/manage/daily-environmental-data'],
  },
];

export const manageParent = {
  name: 'Manage',
  icon: Settings,
  activePaths: ['/manage'],
} as const;

export function isNavItemActive(pathname: string, item: Pick<NavItem, 'href' | 'activePaths'>): boolean {
  const paths = item.activePaths ?? [item.href];
  return paths.some((p) => {
    if (p === '/') return pathname === '/';
    return pathname === p || pathname.startsWith(`${p}/`) || pathname.startsWith(p);
  });
}

export function isManageActive(pathname: string): boolean {
  return pathname.startsWith('/manage');
}
